<template>
  <div
    ref="table"
    class="c-table"
    :class="{
      'c-table_scrolled': isScrolled,
      'c-table_scrolled__last-fixed': isScrolled && fixedColumn === 'last',
      'c-table_scrolled__first-fixed': isScrolled && fixedColumn === 'first',
      'c-table_scroll_end': isScrollEnd,
      'c-table_scroll': isScroll,
    }"
  >
    <m-column-filters
      ref="columnFilters"
      :column="filteredColumn"
      :reference-list="referenceList"
      :active-filters="activeFilteredColumns"
      @getReferenceValues="getReferenceValues"
      @close="filteredColumn = null"
      @setFilter="setColumnFilter"
      @removeFilter="removeColumnFilter"
    />

    <div
      v-if="data.records.length !== 0 && fixedColumn === 'last'"
      :class="{
        'c-table__shadow': data.actions,
        'c-table__shadow_active': data.actions,
        // 'c-table__empty__shadow': data.records.length === 0
      }"
    ></div>
    <div v-if="isScroll" class="c-table__scrollbar-wrapper"></div>

    <perfect-scrollbar ref="wrapper" class="c-table__wrapper" @scroll="scroll">
      <table ref="container" class="c-table__container">
        <thead ref="header" class="c-table__header">
          <tr v-for="i in levels" :key="i" class="c-table__header-row">
            <th
              v-for="(column, columnIndex) in getTableColumns(i)"
              :id="`c-table-column-${column.id}`"
              :key="column.id"
              class="c-table__column"
              :colspan="getColspan(column)"
              :rowspan="getRowspan(column)"
              :class="{
                'c-table__column_with_filter': column.type,
                'c-table__column_hidden': isDisabled(column.id),
                'c-table__column_sorted': isSorted(column),
                'sticky-column sticky-column__first': fixedColumn === 'first' && columnIndex === 0,
                'sticky-column__first-shadow-active': fixedColumn === 'first' && columnIndex === 0 && isScrolled,
              }"
            >
              <div class="c-table__column-wrapper">
                <div
                  class="c-table__column-label"
                  :class="{ 'c-table__column-label-children': !isCategory(column) && sortedColumn, 'c-table__column-no-sort': isColumnNoSort(column) }"

                  @click="setSortedColumn(column, sortedColumn)"
                >
                  {{ column.label }}
                </div>

                <div v-if="column.description || column.type" class="c-table__column-actions">
                  <div v-if="column.fullName" class="c-table__column-action c-table__column-action_description">
                    <c-button :id="`table-column-button-description-${column.id}`" size="small" icon="info" no-border />

                    <b-popover
                      placement="top"
                      triggers="hover"
                      :target="`table-column-button-description-${column.id}`"
                    >
                      {{ column.fullName }}
                    </b-popover>
                  </div>

                  <div v-if="isColumnFiltered(column.id)" class="c-table__column-action">
                    <c-button
                      :id="`table-column-button-filter-${column.id}`"
                      size="small"
                      no-border
                      :active="isColumnActiveFiltered(column.id)"
                      :icon="{
                        icon: 'filter-column',
                        activeColor: 'blue',
                      }"
                      @click="openColumnFilterModal(column)"
                    />

                    <b-popover placement="top" triggers="hover" :target="`table-column-button-filter-${column.id}`">
                      {{ isColumnActiveFiltered(column.id) ? "Изменить фильтр" : "Применить фильтр" }}
                    </b-popover>
                  </div>
                </div>
              </div>
            </th>

            <th
              v-if="data.actions && i === 1"
              class="c-table__column c-table__column_actions"
              :class="{ 'sticky-column sticky-column__last': fixedColumn === 'last' }"
              :rowspan="levels"
            >
              <div class="c-table__column-empty"></div>
            </th>
          </tr>
        </thead>

        <tbody class="c-table__records">
          <tr class="summary_record" v-if="summaryRecord">
            <td :class="{ 'c-table__cell': column.id === 'added_amount' || column.id === 'withdraw_amount' }" v-for="(column, columnIndex) in getTableColumns(levels, true)">
              <div v-if="column.id === 'added_amount'" class="c-table__cell-value">
                <span style="color: #12C971;">{{ data.summaryAddedAmount }}</span>
              </div>
              <div v-if="column.id === 'withdraw_amount'" class="c-table__cell-value">
                <span style="color: #FF238D;">{{ data.summaryWithdrawAmount }}</span>
              </div>
            </td>
            <td v-if="data.actions" class="c-table__cell_actions" :class="{ 'sticky-column sticky-column__last': fixedColumn === 'last' }"></td>
          </tr>
          <tr
            v-for="(record, recordIndex) in data.records"
            :id="`row-${record.id.value}`"
            v-show="record.isShowRow"
            :key="recordIndex"
            class="c-table__record"
            :class="{
              'c-table__summary-record': record.id === 'summary_record',
              'c-table__red': shouldRowBeRed(record),
              'c-table__blue': shouldRowBeBlue(record),
              'c-table__edited': shouldRowBeEdited(record),
            }"
            @click="$emit('handleEditItemClick', record)"
          >
            <td
              v-for="(column, columnIndex) in getTableColumns(levels, true)"
              :key="column.id"
              class="c-table__cell"
              :class="{
                'c-table__cell_string': column.type === 'string',
                'c-table__cell_reference': column.type === 'reference',
                'c-table__cell_number': column.type === 'number',
                'c-table__cell_date': column.type === 'date',
                'c-table__cell_hidden': isDisabled(column.id),
                'sticky-column sticky-column__first': fixedColumn === 'first' && columnIndex === 0,
                'sticky-column__first-shadow-active': fixedColumn === 'first' && columnIndex === 0 && isScrolled,
                ['c-table__cell_' + column.id]: column.id,
                [`c-table__cell__data__${data.type}`]: data.type,
              }"
              :data-cell="record[column.id] && record[column.id].class"
              @click="handleClick(record, column)"
            >
              <div
                v-if="isDefaultCell(record, column)"
                :class="{
                  'c-table__cell-pre-formatted': column.id === 'postCategorySpecialty' && !isCandidatesTableType,
                  'w-250': column.id === 'address',
                }"
                class="c-table__cell-value"
              >
                <span>{{ record[column.id].value }}</span>
              </div>

              <c-table-cell
                v-if="isCustomCellDataType && !isDefaultCell(record, column)"
                class="c-table__cell-cell"
                :cell="getCustomCellId(record[column.id])"
                :data="record[column.id]"
              />

              <c-table-cell
                v-if="record[column.id] && record[column.id].employee"
                class="c-table__cell-cell"
                cell="employee"
                :data="record[column.id].employee"
              />

              <c-table-cell
                v-if="record[column.id] && record[column.id].depositState"
                class="c-table__cell-cell"
                cell="deposit-state"
                :data="record[column.id].depositState"
              />

              <div v-if="column.id === 'worker' || column.id === 'worker_author' || column.id === 'author' || column.id === 'author_update' || column.id === 'author_create' || column.id === 'delete_author'" class="c-table__cell-value">
                <worker-or-user :value="record[column.id]" />
              </div>

              <div v-if="column.id === 'transaction_type'" class="c-table__cell-value">
                <span 
                  :style="record[column.id].style" 
                  v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: record.transaction_type_name.value, placement: 'top' }"
                >
                  {{ record[column.id].value }}
                </span>
              </div> 

              <div v-if="column.id === 'added_amount' || column.id === 'withdraw_amount'" class="c-table__cell-value">
                <span :style="record[column.id].style">{{ record[column.id].value }}</span>
              </div>

              <div v-if="column.id === 'amount'" class="c-table__cell-value">
                <span :style="String(record[column.id].value) !== '0' ? record[column.id].style : ''">{{ record[column.id].value }}</span>
              </div>

              <div v-if="column.id === 'balance'" class="c-table__cell-value">
                <svg-icon v-if="record.use_personal_account" class="c-table__cell-icon" name="ls"></svg-icon>
                <span :style="String(record[column.id].value) !== '0' ? record[column.id].style : ''">{{ record[column.id].value }}</span>
              </div>

              <div v-if="column.id === 'status'" style="display: flex; justify-content: center;" class="c-table__cell-value">
                <svg-icon :name="'status-' + record[column.id].value" v-b-popover.hover.blur.top="record[column.id].title" style="width: 14px; height: 14px;" />
              </div>

              <div v-if="column.id === 'executive'" class="c-table__cell-value">
                <template v-if="record[column.id].workers.length && record[column.id].workers.length < 3">
                  <worker-or-user v-for="worker in record[column.id].workers" :value="worker" :key="worker.worker.id" />
                </template>
                <template v-else-if="record[column.id].workers.length && record[column.id].workers.length >= 3">
                  <router-link
                    target="_blank"
                    :to="{
                      name: 'function-information',
                      query: {
                        id: record.id.value,
                      },
                      hash: '#performers'
                    }"
                    style="white-space: nowrap;"
                  >
                    {{ record[column.id].workers.length + ' ' + declOfNum(record[column.id].workers.length, ["сотрудник", "сотрудника", "сотрудников"]) }}
                  </router-link>
                </template>
                <template v-else-if="record[column.id].posts.length">
                  <div v-for="post in record[column.id].posts">{{ post.post.name }} / {{ post.ranks.length ? post.ranks.map(rank => (rank.name)).join(', ') : "-" }} / {{ post.specialities.length ? post.specialities.map(speciality => (speciality.name)).join(', ') : "-" }}</div>
                </template>
                <template v-else-if="record[column.id].typePosts.length">
                  <div v-for="typePost in record[column.id].typePosts">{{ typePost.name }}</div>
                </template>
                <template v-else>Все</template>
              </div>

              <div v-if="column.id === 'filials'" class="c-table__cell-value">
                <div v-html="record[column.id].value"></div>
              </div>
              
              <div v-if="column.id === 'responsible'" class="c-table__cell-value">
                <template v-if="record[column.id].value.length">
                  <worker-or-user v-for="worker in record[column.id].value" :value="worker" :key="worker.worker.id" />
                </template>
                <template v-else>-</template>
              </div>

              <div v-if="column.id === 'labor_costs'" style="text-align: right;" class="c-table__cell-value">
                <div v-if="record[column.id].value">{{ record[column.id].value }} ч</div>
                <div v-if="record[column.id].repeat_interval" style="color: #8E9CBB; white-space: nowrap;">
                  {{ record[column.id].repeat_interval }} ฿/{{ repeatTypes[record[column.id].repeat_type] }}
                </div> 
              </div>

              <div v-if="column.id === 'indicators'" class="c-table__cell-value">
                <router-link
                  v-if="record[column.id].value"
                  target="_blank"
                  :to="{
                    name: 'function-indicators',
                    query: {
                      id: record.id.value,
                    },
                  }"
                >
                  {{ record[column.id].value }}
                </router-link>
              </div>
            </td>

            <td
              v-if="data.actions"
              class="c-table__cell c-table__cell_actions"
              :class="{ 'sticky-column sticky-column__last': fixedColumn === 'last' }"
            >
              <div class="c-table__cell-actions" :class="{ [`c-table__cell__data__${data.type}`]: data.type }">
                <div v-if="data.type === 'finance' && data.subtype !== 'accountable' " class="finance-actions">
                  <template v-if="record">
                    <c-button-2
                      v-if="record"
                      class="finance-actions__edit"
                      v-b-popover.html="{
                        container: '#app',
                        trigger: 'hover',
                        content: 'Редактировать',
                        placement: 'bottom',
                      }"
                      icon="edit"
                      size="iconic"
                      @click="$emit('editRecord', record)"
                    />

                    <router-link
                      v-if="record.calculation && operationsStatus === 'active'"
                      v-b-popover.html="{
                        container: '#app',
                        trigger: 'hover blur',
                        content: 'Сохраненный расчет по филиалу ' + record.calculation.filial + ' за ' + record.date_created.value,
                        placement: 'top',
                      }"
                      target="_blank"
                      :to="{
                        name: 'save-calculation-production',
                        query: {
                          calc_id: record.calculation.id,
                        },
                      }"
                    >
                      <svg-icon :size="16" name="calculator"></svg-icon>
                    </router-link>
                    
                    <c-button-2
                      v-if="!record.calculation && operationsStatus === 'active'"
                      v-b-popover.html="{
                        container: '#app',
                        trigger: 'hover blur',
                        boundary: 'window',
                        content: 'Удалить операцию',
                        placement: 'top',
                      }"
                      size="iconic"
                      :icon="{ icon: 'trash', color: 'secondary' }"
                      @click="$emit('remove', record)"
                    />

                    <c-button-2
                      v-if="operationsStatus === 'removed'"
                      v-b-popover.html="{
                        container: '#app',
                        trigger: 'hover blur',
                        boundary: 'window',
                        content: 'Восстановить операцию 12',
                        placement: 'top',
                      }"
                      size="iconic"
                      :icon="{ icon: 'restore' }"
                      @click="$emit('restore', record)"
                    />
                  </template>
                </div>

                <div v-if="data.type === 'calculation-sheets'" class="finance-actions">
                  <template v-if="record">
                    <!-- <c-button-2
                      v-if="record"
                      class="finance-actions__edit"
                      v-b-popover.html="{
                        container: '#app',
                        trigger: 'hover',
                        content: 'Редактировать',
                        placement: 'bottom',
                      }"
                      icon="edit"
                      size="iconic"
                      @click="$router.push({ name: `calculation-sheet`, params: { id: record.id.value.replace(/[^0-9]/g, '') } })"
                    /> -->

                    <router-link
                      v-if="record"
                      class="finance-actions__edit"
                      v-b-popover.html="{
                        container: '#app',
                        trigger: 'hover blur',
                        content: 'Редактировать',
                        placement: 'top',
                      }"
                      :to="{
                        name: 'calculation-sheet',
                        params: {
                          id: record.id.value.replace(/[^0-9]/g, ''),
                        },
                      }"
                      @click.stop.native="$emit('handleEditItemClick', record, 'edit')"
                    >
                      <svg-icon :size="16" name="pencil"></svg-icon>
                    </router-link>

                    <router-link
                      v-if="record.calculation && operationsStatus === 'active'"
                      v-b-popover.html="{
                        container: '#app',
                        trigger: 'hover blur',
                        content: 'Сохраненный расчет по филиалу ' + record.calculation.filial + ' за ' + record.date_created.value,
                        placement: 'top',
                      }"
                      target="_blank"
                      :to="{
                        name: 'save-calculation-production',
                        query: {
                          calc_id: record.calculation.id,
                        },
                      }"
                    >
                      <svg-icon :size="16" name="calculator"></svg-icon>
                    </router-link>
                    
                    <c-button-2
                      v-if="!record.calculation && operationsStatus === 'active'"
                      v-b-popover.html="{
                        container: '#app',
                        trigger: 'hover blur',
                        boundary: 'window',
                        content: 'Удалить операцию',
                        placement: 'top',
                      }"
                      size="iconic"
                      :icon="{ icon: 'trash', color: 'secondary' }"
                      @click="$emit('remove', record)"
                    />

                    <c-button-2
                      v-if="operationsStatus === 'removed'"
                      v-b-popover.html="{
                        container: '#app',
                        trigger: 'hover blur',
                        boundary: 'window',
                        content: 'Восстановить операцию',
                        placement: 'top',
                      }"
                      size="iconic"
                      :icon="{ icon: 'restore' }"
                      @click="$emit('restore', record)"
                    />
                  </template>
                </div>
                
                <div v-if="data.type === 'functions'" class="finance-actions">
                  <router-link
                    v-if="record"
                    class="finance-actions__edit"
                    v-b-popover.html="{
                      container: '#app',
                      trigger: 'hover blur',
                      content: 'Редактировать',
                      placement: 'top',
                    }"
                    :to="{
                      name: 'function-information',
                      query: {
                        id: record.id.value,
                      },
                    }"
                  >
                    <svg-icon :size="16" name="pencil"></svg-icon>
                  </router-link>
                </div>
                
                <c-table-actions
                  v-if="data.type === 'employees'"
                  :type="data.type"
                  :record="record"
                  :record-index="recordIndex"
                  :record-count="data.records.length"
                  @disable-show-row="disableRecordShow"
                  @edit-worker="$emit('edit-worker', $event)"
                />
                <c-table-actions
                  v-if="data.type === 'calculations'"
                  :type="data.type"
                  :record="record"
                  :record-index="recordIndex"
                  :record-count="data.records.length"
                  @disable-show-row="disableRecordShow"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </perfect-scrollbar>

    <div v-if="data.records.length === 0" class="c-table__empty__records">{{ emptyRecordsLabel }}</div>
  </div>
</template>

<script>
// @TODO decomposite this component to parts and mixins
import { mapGetters } from "vuex";

import SvgIcon from "@/components/svg-icon";
import Button from "@/components/controls/button";
import Button2 from "@/components/controls2/Button";
import DataTableCell from "@/components/data-table/cell";
import DataTableActions from "@/components/data-table/actions";
import ColumnFiltersModal from "@/components/modals/column-filters";
import WorkerOrUser from "@/components/user/worker-or-user";
import FinanceActions from "./data-table/finance-actions";

const customCells = [
  "employee",
  "depositState",
  "candidateState",
  "source",
  "candidate",
  "candidateStatus",
  "candidateReferral",
  "violationFullNameCell",
  "violationDeadlineCell",
  "fineOrBonusFullNameCell",
  "fineOrBonusDeadlineCell",
  "fineOrBonusAmountCell",
  "worker",
  "style",
  "user",
  "transaction_type",
  "custom"
];

export default {
  name: "c-table",

  components: {
    "c-button": Button,
    "c-button-2": Button2,
    "c-table-cell": DataTableCell,
    "c-table-actions": DataTableActions,
    "m-column-filters": ColumnFiltersModal,
    "c-table-finance-actions": FinanceActions,
    WorkerOrUser,
    SvgIcon
  },

  props: {
    levels: {
      type: Number,
      default: 1,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    enabledFields: {
      type: Array,
      default: () => [],
    },
    disabledColumns: {
      type: Array,
      default: () => [],
    },
    sortedColumn: {
      type: Object,
      default: () => ({}),
    },
    filteredColumns: {
      type: Array,
      default: () => [],
    },
    activeFilteredColumns: {
      type: Array,
      default: () => [],
    },
    referenceList: {
      type: Array,
      default: () => [],
    },
    emptyRecordsLabel: {
      type: String,
      default: "",
    },
    fixedColumn: {
      type: String,
      default: "last",
    },
    operationsStatus: {
      type: String,
      default: "active",
    },
  },

  data() {
    return {
      isScrolled: false,
      isScrollEnd: false,
      isScroll: false,
      positionTop: 0,
      filterFieldsBlockHeight: 0,
      filteredColumn: null,

      repeatTypes: {
        week: "неделю",
        month: "месяц",
        quarter: "квартал",
        year: "год"
      },
    };
  },

  computed: {
    ...mapGetters("app", ["sidebarCollapsed"]),
    summaryRecord() {
      return this.data.records.find((item) => item.id === "summary_record");
    },
    isCandidatesTableType() {
      return this.data.type === "candidates";
    },
    // sortedRecords: function() {
    //   if (!this.sortedColumn) {
    //     return this.data.records
    //   }
    //
    //   let sortedColumn = this.sortedColumn.sortBy
    //   let sortType = (this.sortedColumn.sortType === 'asc') ? 1 : -1
    //   let sortedColumns
    //
    //   if (sortedColumn === 'created') {
    //     sortedColumns = this.data.records.sort(function(a, b) {
    //       let dateA = moment(a[sortedColumn].value, "DD-MM-YYYY").format('X')
    //       let dateB = moment(b[sortedColumn].value, "DD-MM-YYYY").format('X')
    //       if (isNaN(dateA) || isNaN(dateB)) {
    //         return 0
    //       }
    //       if (sortType === -1) {
    //         return (dateB > dateA) ? 1 : (dateA > dateB) ? -1 : 0;
    //       } else if (sortType === 1) {
    //         return (dateA > dateB) ? 1 : (dateB > dateA) ? -1 : 0;
    //       } else {
    //         return 0;
    //       }
    //     })
    //   } else {
    //     sortedColumns = this.data.records.sort(function (a, b) {
    //       if (a[sortedColumn].value.toLowerCase() < b[sortedColumn].value.toLowerCase()) {
    //         return -1 * sortType;
    //       } else if (a[sortedColumn].value > b[sortedColumn].value) {
    //         return 1 * sortType;
    //       } else {
    //         return 0;
    //       }
    //     })
    //   }
    //
    //   return sortedColumns
    // }
    isCustomCellDataType() {
      const types = ["candidates", "violations", "finesAndBonuses"];
      return types.includes(this.data.type);
    },
  },

  watch: {
    enabledFields() {
      this.updatePositionTop();
    },

    isScrollEnd() {

    },

    disabledColumns(value) {
      const enabledColumns = this.data.columns.filter((item) => !value.includes(item.id));

      const max = Math.max.apply(
        null,
        enabledColumns.map((item) => item.level),
      );

      this.$emit("setLevelsTableData", max + 1);
      // this.levels = max + 1;

      this.setTableShadow();
    },
  },

  mounted() {
    this.updatePositionTop();

    window.addEventListener("touchend", this.handleTouchMove, {
      passive: false,
    });
    // window.addEventListener("resize", () => {
    //   setTimeout(() => {
    //     this.updatePositionTop();
    //   }, 0);
    // });
    document.querySelector(".layout").addEventListener("scroll", this.handleLayoutScroll);
    document.querySelector(".ps.c-table__wrapper").addEventListener("scroll", this.handleTableScroll);
    document.addEventListener('click', this.handleOutsideClick);

    this.isScroll = this.$refs.wrapper.$el.clientWidth < this.$refs.wrapper.$el.scrollWidth;
    setTimeout(() => {
      this.setTableShadow();
    }, 1500);
  },
  beforeDestroy() {
    window.removeEventListener("touchend", this.handleTouchMove, {
      passive: false,
    });
    // window.removeEventListener("resize", () => {
    //   setTimeout(() => {
    //     this.updatePositionTop();
    //   }, 0);
    // });
    const layout = document.querySelector(".layout");
    if (layout) {
      layout.removeEventListener("scroll", this.handleLayoutScroll);
    }
    const psElement = document.querySelector(".ps");
    if (psElement) {
      psElement.removeEventListener("scroll", this.handleTableScroll);
    }
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    declOfNum(n, text_forms) {
      n = Math.abs(n) % 100;
      const n1 = n % 10;
      if (n > 10 && n < 20) { return text_forms[2]; }
      if (n1 > 1 && n1 < 5) { return text_forms[1]; }
      if (n1 === 1) { return text_forms[0]; }
      return text_forms[2];
    },
    getCustomCellId(record) {
      return customCells.find((cellId) => cellId in record);
    },
    handleTableScroll() {
      this.setTableShadow();
    },

    handleTouchMove() {
      // if (!e.cancelable) {
      //   e.preventDefault();
      //   return true
      // }
    },

    setTableShadow() {
      if (this.data.actions === undefined || this.fixedColumn === "first") {
        return;
      }
      const ps = document.querySelector(".ps.c-table__wrapper");
      const tableWrapperShadow = document.querySelector(".c-table__shadow");

      if (!ps || !tableWrapperShadow) return;

      const fullScrollWidth = ps.scrollWidth - ps.clientWidth;

      const diff = Math.abs(ps.scrollLeft - fullScrollWidth);

      if (diff > 3) {
        tableWrapperShadow.classList.add("c-table__shadow_active");
      } else {
        tableWrapperShadow.classList.remove("c-table__shadow_active");
      }
    },

    resetColumnFilters() {
      this.$emit("reset-column-filters");
      this.$refs.columnFilters.resetFilters();
    },

    isColumnFiltered(columnId) {
      if (this.filteredColumns === undefined) {
        return false;
      }
      const result = this.filteredColumns.findIndex((i) => i === columnId);

      return result !== -1;
    },

    isColumnActiveFiltered(columnId) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === columnId);

      return c !== -1;
    },

    setColumnFilter(e) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === e.id);

      const filterOptions = {
        id: e.id,
        type: e.type,
        searchType: e.filter.condition.value,
        value: e.type === "number" && e.filter.condition.value === "4" ? e.filter.rangeValue : e.filter.value,
      };

      if (filterOptions.type === "date" && filterOptions.searchType === "range") {
        filterOptions.value = `${e.filter.rangeValue.start},${e.filter.rangeValue.end}`;
      }

      if (
        c === -1 &&
        (filterOptions.type === "string" || filterOptions.type === "number") &&
        filterOptions.value === ""
      ) {
        return;
      }

      if (
        c !== -1 &&
        (filterOptions.type === "string" || filterOptions.type === "number") &&
        filterOptions.value === ""
      ) {
        this.$emit("remove-column-filter", c);
        return;
      }

      if (
        c === -1 &&
        filterOptions.type === "number" &&
        filterOptions.searchType === "4" &&
        (filterOptions.value.end === "" || filterOptions.value.start === "")
      ) {
        return;
      }

      if (
        c !== -1 &&
        filterOptions.type === "number" &&
        filterOptions.searchType === "4" &&
        (filterOptions.value.end === "" || filterOptions.value.start === "")
      ) {
        this.$emit("remove-column-filter", c);
        return;
      }

      if (c === -1 && filterOptions.type === "list" && filterOptions.value.length === 0) {
        return;
      }

      if (c !== -1 && filterOptions.value.length === 0) {
        this.$emit("remove-column-filter", c);
        return;
      }

      if (c === -1) {
        this.$emit("set-column-filter", filterOptions);
      } else {
        this.$emit("remove-column-filter", c);
        this.$emit("set-column-filter-by-index", c, filterOptions);
      }
    },

    isCategory(column) {
      return column.isCategory === 1;
    },

    isColumnNoSort(column) {
      return column.id === "executive" || column.id === "labor_costs" || column.id === "comments" || column.id === "filials"
    },

    isSorted(column) {
      return column.isSorted;
    },

    setSortedColumn(column, sortedColumn) {
      if (column.isCategory !== 1 && sortedColumn !== undefined) {
        const c = this.data.columns.findIndex((i) => i.id === sortedColumn.sortBy);

        if (c !== -1) {
          this.$emit("disable-column-sorted-flag", c);
        }

        column.isSorted = true;

        const sortingData = {
          sortBy: column.id,
          sortType: "asc",
        };

        if (column.id === sortedColumn.sortBy) {
          sortingData.sortType = this.sortedColumn.sortType === "asc" ? "desc" : "asc";
        }

        this.$emit("change-sorting-column", sortingData);
        this.$emit("sortedEvent", sortingData);
      }
    },

    removeColumnFilter(columnId) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === columnId);

      if (c !== -1) {
        this.$emit("remove-column-filter", c);
      }
    },

    openColumnFilterModal(column) {
      const c = this.filteredColumns.findIndex((i) => i === column.id);

      if (c !== -1) {
        this.filteredColumn = column;
      }
    },

    handleLayoutScroll() {
      const layout = document.querySelector(".layout");
      const app = document.querySelector(".app");
      const recordElement = document.querySelector(".c-table__summary-record");

      let result = layout.scrollTop - this.positionTop;

      if (app.offsetWidth < 992) {
        result += 50;
      }

      if (layout.scrollTop > this.positionTop) {
        if (recordElement) {
          recordElement.classList.add("c-table__header-shadow");
          recordElement.style.transform = `translateY(${result - 3}px)`;
        }
        if (this.$refs.header) {
          if (!recordElement) {
            this.$refs.header.classList.add("c-table__header-shadow");
          }
          this.$refs.header.style.transform = `translateY(${result}px)`;
        }
      } else {
        if (recordElement) {
          recordElement.classList.remove("c-table__header-shadow");
          recordElement.style.transform = "none";
        }
        if (this.$refs.header) {
          this.$refs.header.classList.remove("c-table__header-shadow");
          this.$refs.header.style.transform = "none";
        }
      }
    },

    updatePositionTop() {
      const header = this.$refs.header.getBoundingClientRect();
      const layout = document.querySelector(".layout");
      this.positionTop = header.top + layout.scrollTop;
    },

    isDefaultCell(record, column) {
      if (!record[column.id]) {
        return false;
      }
      let isDefault = true;
      customCells.forEach((cell) => {
        if (!isDefault) {
          return;
        }
        if (typeof record[column.id] === "object" && cell in record[column.id]) {
          isDefault = false;
        }
      });

      return isDefault;
    },

    getChildrens(columnId) {
      return this.data.columns.filter((item) => item.parentColumnId === columnId);
    },

    getTableColumns(level, s) {
      let out = [];

      const columns = this.data.columns.filter((item) => item.parentColumnId === undefined);

      if (this.data.sortedColumn) {
        columns.forEach((column) => {
          if (column.id === this.data.sortedColumn.sortBy) {
            column.isSorted = true;
          }
        });
      }

      if (level === 1) {
        out = out.concat(columns);
      } else if (level === 2) {
        Object.keys(columns).forEach((i) => {
          out = out.concat(this.getChildrens(columns[i].id));
        });
      } else if (level === 3) {
        Object.keys(columns).forEach((i) => {
          const childrens = this.getChildrens(columns[i].id);
          if (s) {
            if (childrens.length === 0) out = out.concat([columns[i]]);
          }

          Object.keys(childrens).forEach((ii) => {
            const childrens2 = this.getChildrens(childrens[ii].id);
            if (s) {
              if (childrens2.length === 0) out = out.concat([childrens[ii]]);
            }
            out = out.concat(childrens2);
          });
        });
      }

      return out;
    },

    getColumns(level) {
      let cols = [];

      if (level === 1) {
        cols = this.data.columns.filter((col) => col.parentColumnId === undefined);
      } else if (level === 2) {
        const rootCols = this.data.columns.filter((col) => col.parentColumnId === undefined);

        Object.keys(rootCols).forEach((i) => {
          const rootCol = rootCols[i];

          const childrens = this.data.columns.filter((col) => col.parentColumnId === rootCol.id);

          cols = cols.concat(childrens);
        });
      } else if (level === 3) {
        const rootCols = this.data.columns.filter((col) => col.parentColumnId === undefined);

        Object.keys(rootCols).forEach((i) => {
          const rootCol = rootCols[i];

          const childrens = this.data.columns.filter((col) => col.parentColumnId === rootCol.id);

          Object.keys(childrens).forEach((ii) => {
            const childrens2 = this.data.columns.filter((col) => col.parentColumnId === childrens[ii].id);
            cols = cols.concat(childrens2);
          });
        });
      }

      return cols;
    },

    getColspan(column) {
      const children = this.data.columns.filter((col) => col.parentColumnId === column.id);

      let count = children.length;

      if (column.level === 0) {
        Object.keys(children).forEach((c) => {
          const childrenChildren = this.data.columns
            .filter((col) => col.parentColumnId === children[c].id)
            .filter((colChild) => !this.disabledColumns.includes(colChild.id));

          count += childrenChildren.length;
        });
      }

      Object.keys(children).forEach((i) => {
        const result = this.disabledColumns.find((item) => item === children[i].id || children[i].isCategory === 1);

        if (result) {
          count -= 1;
        }
      });

      return count;
    },

    getRowspan(column) {
      const children = this.data.columns.filter((col) => col.parentColumnId === column.id);

      if (this.levels === 3) {
        if (column.level === 0 && children.length === 0) {
          return 3;
        }
        if (column.level === 1 && children.length === 0) {
          return 2;
        }
      } else if (this.levels === 2) {
        if (column.level === 0 && children.length === 0) {
          return 2;
        }
      }

      return 1;
    },

    getSeletItemLabel(record, column) {
      let cell = null;

      if (column.items) {
        const item = column.items.find((i) => i.value === record[column.name]);

        cell = item ? item.label : "-";
      } else {
        cell = "-";
      }

      return cell;
    },

    scroll() {
      // const layout = document.querySelector(".layout");
      // layout.classList.add('layout-touch-action-none');
      this.isScrolled = this.$refs.wrapper.$el.scrollLeft > 0;
      const containerWidth = this.$refs.container.offsetWidth;
      const wrapperWidth = this.$refs.wrapper.$el.offsetWidth;
      const { scrollLeft } = this.$refs.wrapper.$el;
      this.isScrollEnd = containerWidth - scrollLeft === wrapperWidth - 1;
      // layout.classList.remove('layout-touch-action-none');
    },

    isDisabled(id) {
      return this.disabledColumns.find((item) => item === id);
    },

    getReferenceValues(e) {
      this.$emit("getReferenceValues", e);
    },

    disableRecordShow(recordId) {
      this.data.records.forEach((record) => {
        if (record.id === recordId) {
          record.isShowRow = false;
        }
      });
    },
    shouldRowBeRed(record) {
      if ("doesRequireExplanatory" in record) {
        return record.doesRequireExplanatory && !record.explanatory.entity;
      }
      return false;
    },
    shouldRowBeBlue(record) {
      if ("explanatory" in record) {
        const { entity, isReviewed } = record.explanatory;
        return entity && !isReviewed;
      }
      return false;
    },

    shouldRowBeEdited(record) {
      const clicked = this.$store.state.calculationSheets.clickedRecord;

      const storedId = clicked && clicked.id && clicked.id.value;
      const recordIdValue = record && record.id && record.id.value;

      return storedId && recordIdValue && storedId === recordIdValue;
    },

    handleClick(record, column) {
      const value = record[column.id];
      if (value && value.onClick) {
        this.$emit(value.onClick, value);
      }
    },
    handleOutsideClick(event) {
      const tableEl = this.$refs.table;
      if (tableEl && !tableEl.contains(event.target)) {
        this.removeCurrentRecord();
      }
    },
    removeCurrentRecord() {
      this.$store.dispatch('calculationSheets/setCurrentRecord', null);
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/vars";

.c-table {
  position: relative;
  display: inline-block;
  max-width: 100%;

  &__red {
    background-color: #ffe6f2;
  }
  &__blue {
    background-color: #e1edff;
  }
  &__edited {
    border: 3px solid #ff238d;
    //background-color: rgba(255, 35, 141, 0.05);
    background-color: $color-bg;
  }

  &__summary-record {
    background: #f5f7fa;
    height: 38px;
    position: relative;
    z-index: 25;

    & .c-table__cell {
      border-left: none !important;
      border-right: none !important;
      position: relative;
    }
    & .c-table__cell:last-child,
    & .c-table__cell_bonuses {
      border-right: 1px solid #dfe4ef !important;
    }
    & .c-table__cell:first-child,
    & .c-table__cell_deposit {
      border-left: 1px solid #dfe4ef !important;
    }
    & .c-table__cell_deposit,
    & .c-table__cell_personalAccount,
    & .c-table__cell_premiumAccount,
    & .c-table__cell_bonuses,
    & .c-table__cell_fouls,
    & .c-table__cell_penalties {
      border-left: 1px solid #dfe4ef !important;
    }
  }

  &__scrollbar-wrapper {
    position: fixed;
    height: 24px;
    background: white;
    box-shadow: $box-shadow;
    bottom: 0;
    left: 0;
    z-index: 100;
    transition: 0.2s;

    @media screen and (max-width: 992px) {
      display: none;
    }
  }

  @media screen and (max-width: 992px) {
    max-width: 100%;
  }

  @media screen and (max-width: 700px) {
    margin: 0 -20px;
    width: calc(100% + 40px);
    max-width: none;
  }

  &__wrapper {
    overflow-x: auto;
    position: relative;
    transition: 0.2s;
    display: inline-block;
    width: 100%;

    &::-webkit-scrollbar {
      height: 0;
    }

    @media screen and (max-width: 992px) {
      width: 100%;
    }
  }

  &__shadow {
    position: absolute;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
    width: 10px;
    height: calc(100% - 10px);
    right: 92px;
    opacity: 0;
    bottom: 10px;
    visibility: hidden;
    z-index: 80;
    transition: 0.2s;
  }

  &__empty__shadow {
    right: 0;
  }

  &__empty__records {
    border: 1px solid $color-border-alt;
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: $z-index-loader;
    background: white;
    color: $label;
    font-size: 15px;
  }

  &__shadow_active {
    opacity: 0.15;
    visibility: visible;
  }

  &_scroll {
    .c-table__shadow {
      visibility: hidden;
      opacity: 0;
    }

    .c-table__shadow_active {
      visibility: visible;
      opacity: 0.15;
    }

    .c-table__column_actions {
      &:after {
        visibility: visible !important;
        opacity: 0.15 !important;
      }
    }

    &.c-table_scroll_end {
      .c-table__shadow {
        visibility: hidden;
        opacity: 0;
      }

      .c-table__column_actions {
        &:after {
          visibility: hidden !important;
          opacity: 0 !important;
        }
      }
    }
  }

  &_scrolled {
    border-left: 1px solid $color-border-light;

    @media screen and (max-width: 992px) {
      border-left: none;

      &__last-fixed:before {
        background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
        left: 0;
      }
      &__first-fixed:before {
        background: linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
        right: 0;
      }

      &:before {
        position: absolute;
        content: "";
        width: 22px;
        height: 100%;
        top: 0;
        z-index: 100;
      }
    }
  }

  .c-table {
    &__container {
      border-collapse: collapse;
      width: calc(100% - 1px);
    }

    &__header {
      border-bottom: 2px solid $color-border-light;
      position: relative;
      background: $color-border-light;
      z-index: 70;
    }

    &__header-shadow:after {
      content: "";
      position: absolute;
      background: linear-gradient(#001550, rgba(255, 255, 255, 0));
      width: 100%;
      height: 10px;
      opacity: 0.15;
      z-index: 69;
      bottom: -10px;
      left: 0;
    }

    &__column {
      text-align: left;
      border: 1px solid $color-border-light;
      vertical-align: top;
      height: 1px;
      padding: 0;
      transition: 0.2s;

      &_hidden {
        width: 0;
        border: none;
        overflow: hidden;
        display: none;
        // margin-left: -1px;

        .c-table__column-wrapper {
          width: 0;
          padding: 0;
          border: none;
        }
      }

      &_with {
        &_filter {
          .c-table__column {
            &-wrapper {
              flex-direction: column;
            }

            &-actions {
              margin-top: 10px;
            }
          }
        }
      }

      &_sorted {
        .c-table__column-label {
          color: $color-primary;
        }
      }

      &-label {
        color: $color-label;
        font: {
          size: 12px;
          weight: 500;
        }
        line-height: 13px;

        &-children {
          cursor: pointer;
        }
      }

      &-no-sort {
        pointer-events: none;
      }

      &-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px;
        height: 100%;
        background: white;
      }

      &-actions {
        display: flex;
        justify-content: space-between;
      }

      &-action {
        width: 14px;
        height: 14px;

        .c-button {
          width: 14px;
          height: 14px;
        }

        &_description {
          margin-left: -3px;
        }
      }

      &_actions {
        &:after {
          content: "";
          position: absolute;
          // background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
          width: 10px;
          height: 100%;
          left: -11px;
          opacity: 0;
          bottom: 0;
          visibility: hidden;
          z-index: 40;
          background: unset;
        }

      }

      &-empty {
        background: white;
        width: calc(100% + 1px);
        height: calc(100% + 2px);
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        border-bottom: 2px solid $color-border-light;
        margin-left: -1px;
        position: relative;
      }
    }

    &__cell {
      border: 1px solid $color-border-light;
      padding: 0;
      height: 1px;
      transition: 0.2s;

      &_number {
        & .c-table__cell-value {
          text-align: right;
        }
      }
      &_phone {
        white-space: nowrap;
      }

      &_rank {
        & .c-table__cell-value {
          text-align: left;
        }
      }
      &_reason {
        & .c-table__cell-value {
          width: 263px;
        }
      }
      &_deadline .c-table-cell {
        display: flex;
        align-items: center;
      }

      &_hidden {
        width: 0;
        overflow: hidden;
        border: none;
        display: none;

        .c-table__cell-value,
        .c-table__cell-cell {
          width: 0;
          padding: 0;
        }
      }

      &-cell {
        transition: 0.2s;
      }

      &-value {
        line-height: 13px;
        font-size: 13px;
        padding: 10px;
        transition: 0.2s;
      }

      &-pre-formatted span,
      &_post span {
        white-space: pre;
      }

      //&_actions {
      //  position: sticky;
      //  right: 0;
      //  border-right: none;
      //  z-index: 20;
      //}

      &-actions {
        background: white;
        width: calc(100% + 1px);
        height: 100%;
        display: flex;
        align-items: center;
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        margin-left: -1px;
      }
    }
  }
}

::v-deep .c-table__summary-record .c-table__cell-actions {
  background: #f5f7fa;
  z-index: 999999;
}

::v-deep .ps__rail-x {
  z-index: 351;
  background: #ffffff !important;
}

::v-deep .ps__rail-x:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-30px, 0);
  box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
  z-index: -1;
  height: 24px;
  width: calc(100vw - 60px);
  background: #ffffff;
}

::v-deep .ps__rail-x:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, calc(-50% + 1px));
  border-radius: 10px;
  z-index: -1;
  height: 4px;
  width: calc(100% - 34px);
  background: #dfe4ef;
}
.w-250 {
  width: 250px !important;
}
.sticky-column {
  position: sticky;
  border-right: none;
  z-index: 28;
  background-color: #FFFFFF;

  &__last {
    right: 0;
    position: sticky !important;
  }
  &__first {
    left: -1px;

    &-shadow-active {
      &::before {
        content: "";
        position: absolute;
        right: -10px;
        top: 0;
        bottom: 0;
        width: 10px;
        background: -webkit-gradient(linear, left top, right top, from(#001550), to(rgba(255, 255, 255, 0)));
        background: linear-gradient(to right, #001550 0%, rgba(255, 255, 255, 0) 100%);
        opacity: 0.15;
      }
    }
  }
}
.c-table__cell__data {
  &__candidates {
    & > div {
      display: flex;
      align-items: flex-start;
      width: 100%;
      height: 100%;
    }
  }
}
.finance-actions {
  padding: 0 15px;
}

.summary_record {
  background-color: #F5F7FA;
  border-left: 1px solid #DFE4EF;
  border-right: 1px solid #DFE4EF;

  .sticky-column {
    background-color: #F5F7FA;
  }
}
.finance-actions {
  display: flex;
  align-items: center;
}
.finance-actions__edit {
  margin-right: 10px;
}
.c-table__cell_money_source {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis
}
.c-table__cell_comment {
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis
}
.c-table__cell_balance {
  .c-table__cell-value {
    padding: 0;
    position: relative;

    .c-table__cell-icon {
      position: absolute;
      top: 50%;
      left: 11px;
      transform: translateY(-50%);
    }
  }

  span {
    width: 100%;
    height: 100%;
    display: inline-block;
    padding: 10px;
  }
}
</style>
